import React from "react";
import styled from "styled-components";
import withToggle from "../withToggle";
import DescriptionList from "../DescriptionList";
import SVGIcon from "../SVGIcon";

const Descriptions = styled.div`
  text-align: center;
  margin-top: 2rem;
  @media (min-width: 640px) {
    text-align: left;
  }
`;

const StyledLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ComponentDescriptions = ({ descriptionsShow, toggleDescriptionsShow, selected }) => (
  <Descriptions>
    <StyledLink onClick={toggleDescriptionsShow}>
      <SVGIcon icon="list" /> {descriptionsShow ? "Hide" : "Show"} component descriptions
    </StyledLink>
    {descriptionsShow ? (
      <DescriptionList onClose={toggleDescriptionsShow} selected={selected} />
    ) : null}
  </Descriptions>
);

export default withToggle({ name: "descriptions", trueName: "show", falseName: "hide" })(
  ComponentDescriptions
);
